
import { useState, useEffect } from 'react';
import AiChatbot from 'pages/ai-chat-bot/index';
import { Routes, useNavigate, BrowserRouter as Router, Route } from "react-router-dom"
import Login from 'pages/login/index';
import PrivateRoute from 'routes/PrivateRoutes';
import Dashboard from 'pages/dash-board';
import ResetPassword from 'pages/reset-password';
import ChangePassword from 'pages/change-password';
import Signup from 'pages/signup';
import ForgotPassword from 'pages/forgot-password';
import Baselayout from 'layout/Baselayout';
import { ToastContainer } from 'react-toastify';
import PublicRoute from 'routes/PublicRoutes';
import { setStopId } from 'redux/counterSlice';
import { useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css'

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    if ('speechSynthesis' in window) {
      const synth = window.speechSynthesis;
      synth.cancel();
    }
    dispatch(setStopId(''));
  }, [])
  return (
    <div className="app">
      <ToastContainer
        autoClose={1500}
        closeOnClick={true}
        pauseOnFocusLoss
        pauseOnHover
        position="bottom-right"
      />
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route path="*" element={<Baselayout />} />
        </Route>

        <Route element={<PublicRoute />}>
          <Route path={"/login"} element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

      </Routes>

    </div>

  );
}

// function Home({ showAIChatbotComponent, setShowAIChatbotComponent }: any) {
//   return <>

//     <div className="chat-component">
//       {showAIChatbotComponent && <AiChatbot setShowAIChatbotComponent={setShowAIChatbotComponent} />}
//     </div>

//   </>
// }

export default App;